import { render, staticRenderFns } from "./PendingProfilesList.vue?vue&type=template&id=4256bcdb&"
import script from "./PendingProfilesList.vue?vue&type=script&lang=js&"
export * from "./PendingProfilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports